<template>
	<div id="top-type-area">
		<div class="func-bar" v-if="selectedType != null">
			<!-- 面包屑 -->
			<div class="center-common-breadcrumb">
				<span>{{ cur_lang == "zh" ? selectedType.nameCh : selectedType.nameEn }}</span>
				<span style="width: 20px; text-align: center;">/</span>
				<span>{{ cur_lang == "zh" ? "详情介绍" : "Type introduction" }}</span>
			</div>
		</div>
		
		<div class="top-type-content"
			style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
			<div id="content" style="width: 80%;"></div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "TopType",
		data() {
			return {
				selected_type_index: 0,
				selectedType: null,
				cur_lang: "zh"
			};
		},

		created() {
			let cur_lang = localStorage.getItem("locale");
			if (cur_lang) {
				this.cur_lang = cur_lang
			}
			
			// 获取链接从?号开始的参数,如:  ?a=1&b=2
			let url = location.search;
			// 去除问号
			let str = url.substr(1);
			// 分离参数
			let strArray = str.split("&");
			for (let i = 0; i < strArray.length; i++) {
				let paramer = strArray[i];
				if (paramer.indexOf('type_index') != -1) {
					// 解码参数，获取信息
					this.selected_type_index = decodeURIComponent(strArray[0].replace("type_index=", ""));
				} 
			}
			
		},
		
		
		mounted() {
			
			this.showIntro();
			
			const that = this;
			window.addEventListener("setItem", function(e) {
				// console.log('top type info 监听到了: ', e.key);
				if (e.key == 'locale') {
					// 监听切换中英
					that.cur_lang = e.newValue;
					that.showIntro();
				} else if (e.key == 'is_update_top_type') {
					// 更新类型
					that.selected_type_index = e.newValue;
					that.showIntro();
				} else if (e.key == 'all_product_type_list') {
					// product menu 请求并保存类型 完成时
					that.showIntro();
				}
			});
		},

		methods: {
			
			showIntro: function(){
				let types = JSON.parse(sessionStorage.getItem("all_product_type_list"));
				if (types == null) return;
				this.selectedType = types[this.selected_type_index];
				// console.log('selectedType: ', this.selectedType);
				let t = document.getElementById("content");
				if (t != null) {
					// 重点：将字符串解析成html进行展示
					t.innerHTML = this.cur_lang == "zh" ? this.selectedType.articleCh : this.selectedType.articleEn;
				}
			},
			
			
		}
	};
</script>

<style>
	#top-type-area {
		width: 100%;
	}

	.func-bar {
		width: 100%;
		min-height: 50px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #cccccc;
	}

	.center-common-breadcrumb {
		width: 65%;
		height: 100%;
		font-size: 18px;
		margin-left: 10px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

</style>
